import type { TableOptions, Table } from '../../common/types/general';
import type { Client } from '../../common/types/client';
import formatter from '../../common/helpers/formatter';
import sort from '../../common/helpers/sort';

const reactAppVersion = process.env.REACT_APP_VERSION;

const dndTable: Table<Client>[] = [
  { headline: 'Name', type: 'text', value: (client) => client.name || '' },
  { headline: 'Telefon', type: 'text', value: (client) => formatter.formatPhoneNumber(client.phone) },
  { headline: 'E-Mail', type: 'email', value: (client) => client.email },
  { headline: 'Berater*in-/Therapeut*in-Code', type: 'text', value: (client) => client.consultantCode || '' },
  { headline: 'Fall-Kennnummer', type: 'text', value: (client) => client.caseId || '' },
  { headline: '', type: 'delete', value: () => '' },
];

const fbTable: Table<Client>[] = [
  { headline: 'Name', type: 'text', sortable: 'name', value: (client) => client.name || '' },
  { headline: 'Telefon', type: 'text', value: (client) => formatter.formatPhoneNumber(client.phone) },
  { headline: 'E-Mail', type: 'email', value: (client) => client.email },
  { headline: 'Beraterin', type: 'text', value: (client) => client.advisor },
  {
    headline: 'Erstkontakt',
    type: 'text',
    sortable: 'date',
    value: (client) => formatter.formatGermanDate(client.firstContactDate),
  },
  { headline: '', type: 'delete', value: () => '' },
];

const fhfTable: Table<Client>[] = [
  { headline: 'Name', type: 'text', sortable: 'name', value: (client) => client.name || '' },
  { headline: 'Telefon', type: 'text', value: (client) => formatter.formatPhoneNumber(client.phone) },
  { headline: 'E-Mail', type: 'email', value: (client) => client.email },
  { headline: 'Fallzuständigkeit', type: 'text', value: (client) => client.advisor },
  {
    headline: 'Erstkontakt',
    type: 'text',
    sortable: 'firstContactDate',
    value: (client) => formatter.formatGermanDate(client.firstContactDate),
  },
  { headline: '', type: 'delete', value: () => '' },
];

const fhbfTable: Table<Client>[] = [
  { headline: '', type: 'select', value: () => '' },
  { headline: 'Name', type: 'text', sortable: 'name', value: (client) => client.name || '' },
  { headline: 'Telefon', type: 'text', value: (client) => formatter.formatPhoneNumber(client.phone) },
  { headline: 'Fallzuständigkeit', type: 'text', value: (client) => client.advisor },
  { headline: 'Fall-Nr.', type: 'text', sortable: 'caseId', value: (client) => client.caseId },
  {
    headline: 'Erlaubnis zur Datenspeicherung',
    type: 'boolean',
    sortable: 'dataStorage',
    value: (client) => client.dataStorage,
  },
  {
    headline: 'Datum',
    type: 'text',
    sortable: 'date',
    value: (client) => formatter.formatGermanDate(client.date),
  },
  { headline: '', type: 'delete', value: () => '' },
];

const getTableOptions = (): TableOptions<Client> => {
  if (reactAppVersion === 'dnd') {
    return {
      table: dndTable,
      sort: (itemA, itemB) => sort.sortByNumericString(itemA.caseId, itemB.caseId, 'DESC'),
      filter: (searchValue, item) =>
        (item.name || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.consultantCode || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.caseId || '').toLowerCase().includes(searchValue.toLowerCase()),
    };
  }
  if (reactAppVersion === 'fb') {
    return {
      table: fbTable,
      sort: (itemA, itemB, sortBy) => {
        if (sortBy != null && sortBy.sortable === 'name') {
          return sort.sortByString(itemA.name, itemB.name, sortBy.order);
        }
        return sort.sortByDate(itemA.firstContactDate, itemB.firstContactDate, sortBy != null ? sortBy.order : 'DESC');
      },
      filter: (searchValue, item) =>
        (item.name || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.advisor || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.phone || '').toLowerCase().includes(searchValue.toLowerCase()),
    };
  }
  if (reactAppVersion === 'fhbf') {
    return {
      table: fhbfTable,
      sort: (itemA, itemB, sortBy) => {
        if (sortBy != null && sortBy.sortable === 'caseId') {
          return sort.sortFhbfCaseId(itemA.caseId, itemB.caseId, sortBy.order);
        }
        if (sortBy != null && sortBy.sortable === 'name') {
          return sort.sortByString(itemA.name, itemB.name, sortBy.order);
        }
        return sort.sortByDate(itemA.firstContactDate, itemB.firstContactDate, sortBy != null ? sortBy.order : 'DESC');
      },
      filter: (searchValue, item) =>
        (item.name || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.advisor || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.phone || '').toLowerCase().includes(searchValue.toLowerCase()),
    };
  }
  if (reactAppVersion === 'fhf') {
    return {
      table: fhfTable,
      sort: (itemA, itemB, sortBy) => {
        if (sortBy != null && sortBy.sortable === 'name') {
          return sort.sortByString(itemA.name, itemB.name, sortBy.order);
        }
        return sort.sortByDate(itemA.firstContactDate, itemB.firstContactDate, sortBy != null ? sortBy.order : 'DESC');
      },
      filter: (searchValue, item) =>
        (item.name || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.advisor || '').toLowerCase().includes(searchValue.toLowerCase()) ||
        (item.phone || '').toLowerCase().includes(searchValue.toLowerCase()),
    };
  }
  return { table: [], sort: () => 1, filter: () => true };
};
export default getTableOptions;
